import { render, staticRenderFns } from "./MomentsReceivedLeaderboard.vue?vue&type=template&id=4f2b57a5&"
import script from "./MomentsReceivedLeaderboard.vue?vue&type=script&lang=js&"
export * from "./MomentsReceivedLeaderboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports